import type { FC } from 'react';

import classNames from 'classnames';
import _isObject from 'lodash-es/isObject';

import type { VariantType } from '../../constants/variants';
import Label from '../../ui/label/label';

import styles from './labels.module.css';

type Props = {
  className?: string;
  labelClassName?: string;
  variant: VariantType;
  items: { value: string }[];
};

const Labels: FC<Props> = ({
  variant,
  className,
  labelClassName,
  items = [],
}) => {
  const labelsComponents = items.map((item, i) => {
    const value = _isObject(item) ? item.value : item;
    return (
      <Label
        key={i}
        variant={variant}
        className={classNames(labelClassName, styles.label)}
      >
        {value}
      </Label>
    );
  });
  return (
    <div className={classNames(className, styles.labels)}>
      {labelsComponents}
    </div>
  );
};

export default Labels;
